import { useSession } from '../access/session';
import { preferenceKey } from '../lib/feedPreferences';
import { useFilters } from './filters';
import { useProfile } from './profile';
import { isApp, isReadyFeed, isStudio } from './route';
import { diagnosticSelection, type SelectionSource } from './diagnosticSelection';

/** The scanner publishes only venue choices. No cookies, tokens, URLs or commands. */
export function installDiagnosticFilterSync(): void {
  if (!(isApp(location.pathname) || isReadyFeed(location.pathname) || isStudio(location.pathname))) return;
  let source: SelectionSource = 'filters';
  let intentional = false;
  const sourceKey = () => preferenceKey('diagnostic-source.' + (useSession.getState().me.id ?? ''));
  const restore = () => {
    try { const saved = localStorage.getItem(sourceKey()); intentional = saved === 'studio' || saved === 'filters'; source = saved === 'studio' || (!saved && !useFilters.getState().venues.length && !useFilters.getState().mainVenues.length && Object.values(useProfile.getState().profile?.books ?? {}).some(Boolean)) ? 'studio' : 'filters'; } catch { source = 'filters'; }
  };
  restore();
  let timer: ReturnType<typeof setTimeout>;
  function send() {
    const me = useSession.getState().me;
    if (!me.authenticated || !me.id || (document.visibilityState === 'hidden' || !document.hasFocus())) return;
    const ids = diagnosticSelection(useFilters.getState(), useProfile.getState().profile?.books ?? {}, source);
    if (!ids.length && !intentional) return;
    window.postMessage({ channel: 'forq:diagnostic:scanner', id: crypto.randomUUID(), op: 'filterSync', accountId: me.id, ids, source }, location.origin);
  }
  function schedule(next?: SelectionSource) {
    if (next) { intentional = true; source = next; try { localStorage.setItem(sourceKey(), source); } catch { /* local browser only */ } }
    clearTimeout(timer); timer = setTimeout(send, 250);
  }
  useFilters.subscribe((next, prev) => {
    const choice = (f: typeof next) => JSON.stringify([f.venues, f.mainVenues, f.venueMode]);
    if (choice(next) !== choice(prev)) schedule('filters');
  });
  useProfile.subscribe((next, prev) => {
    if (JSON.stringify(next.profile?.books ?? {}) !== JSON.stringify(prev.profile?.books ?? {})) schedule('studio');
  });
  useSession.subscribe((next, prev) => { if (next.me.id !== prev.me.id || next.me.authenticated !== prev.me.authenticated) { restore(); schedule(); } });
  window.addEventListener('focus', () => schedule());
  document.addEventListener('visibilitychange', () => schedule());
  // A reopened extension/worker receives the current snapshot without changing the scanner.
  setInterval(send, 15000);
  schedule();
}
